/* Keyboard Events for Slider widget */


define([
    "dojo/_base/declare",
    "dojo/on",
    "dojo/aspect",
    "dojo/keys",
    "../ToolstripUtils"
], function (declare, on, aspect, keys, ToolstripUtils) {
    return declare(null, {

        //TODO: use postcreate( and use this.inherited(arguments);

        constructor: function () {
            this.own(aspect.after(this, "postCreate", this._attachKeyBoardEvent, true));
        },
        // Pressing the left arrow moves to the previous closest step
        // Pressing the right arrow moves to the next closest step
        _attachKeyBoardEvent: function () {
            var i, value;
            this.own(on(this, "keyup", function (event) {
                if(!this.get("disabled"))
                {
                    var closestSteps = [], currentIndex, previousStep, nextStep, posArray = [], stepSize = (this.maximum -
                        this.minimum) / this.steps;
                    for (i = this.minimum; i <= this.maximum; i = i + stepSize) {
                        posArray.push(i);
                    }
                    if ((event.keyCode === keys.LEFT_ARROW) || (event.keyCode === keys.PAGE_DOWN)) {
                        //find closest step value based on current value
                        // Get first value in array which will be the previous step
                        closestSteps =
                            ToolstripUtils.getClosestValue(posArray, this.get("value"))[0];
                        // Get the current index, so that we can find the previous step
                        currentIndex = posArray.indexOf(closestSteps);
                        // If you are at minimum value, the index is 0, so pressing the left arrow should not do anything
                        if (currentIndex === 0) {
                            previousStep = posArray[0];
                        } else {
                            previousStep = posArray[currentIndex - 1];
                        }
                        //set its value
                        this.set("value", previousStep);

                    } else if ((event.keyCode === keys.RIGHT_ARROW) || (event.keyCode === keys.PAGE_UP)) {
                        //find closest step value based on current value
                        // Get first value in array, which will be the next step
                        closestSteps =
                            ToolstripUtils.getClosestValue(posArray, this.get("value"))[1];
                        // Get the current index, so that we can find the previous step
                        currentIndex = posArray.indexOf(closestSteps);
                        // If you are at minimum value, the index is 0, so pressing the right arrow should go to first step
                        if (currentIndex === 0) {
                            nextStep = posArray[1];
                        } else if (currentIndex === posArray.length - 1) {
                            nextStep = posArray[posArray.length - 1];
                        } else {
                            nextStep = posArray[currentIndex + 1];
                        }
                        //set its value
                        this.set("value", nextStep);
                    } else if ((event.keyCode === keys.END)) {
                        nextStep = posArray[posArray.length -1];
                        this.set("value", nextStep);
                    } else if ((event.keyCode === keys.HOME)) {
                        nextStep = posArray[0];
                        this.set("value", nextStep);
                    }
                }
            }));

        }
    });
});

